import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Blog() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setList(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="blog-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <div className="label-eyebrow mb-4">Editorial</div>
      <h1 className="text-5xl lg:text-6xl font-heading text-white mb-6">The Journal</h1>
      <p className="text-hsecondary max-w-2xl">Notes on ritual, recovery, and the craft of hospitality.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
        {list.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-${p.slug}`} className="group">
            <div className="aspect-video overflow-hidden mb-4">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="label-eyebrow text-white/50 mb-2">{p.category}</div>
            <h3 className="font-heading text-xl text-white group-hover:text-hgold transition-colors">{p.title}</h3>
            <p className="text-hsecondary text-sm mt-2 leading-relaxed">{p.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
